import React from 'react';
import { Epoch } from '../../types/epochs';
import { useYears } from '../../hooks/useYears';

interface TimelineProps {
  epochs: Epoch[];
  hoveredEpoch: string | null;
}

export const Timeline: React.FC<TimelineProps> = ({ epochs, hoveredEpoch }) => {
  const years = useYears(epochs);

  return (
    <div className="timeline">
      {years.map(year => (
        <div
          key={year}
          className={`year ${hoveredEpoch &&
            epochs.find(e => e.title === hoveredEpoch)?.events
              .some(event => parseInt(event.year) === year)
            ? 'highlighted'
            : ''
          }`}
        >
          {year}
        </div>
      ))}
    </div>
  );
}; 